"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loader = exports.loadScriptCallback = exports.$svg = exports.$div = exports.$element = exports.$helper = exports.ElementHelper = exports.setStyle = exports.before = exports.after = exports.remove = exports.append = exports.hasClass = exports.toggleClass = exports.removeClass = exports.addClass = exports.empty = exports.svgElement = exports.htmlDiv = exports.htmlElement = exports.urlLinkPipe = exports.DOMContentLoaded = exports.startOnLoaded = void 0;
var lodash_1 = require("lodash");
var rxjs_1 = require("rxjs");
var lodash_2 = require("lodash");
function startOnLoaded(callback) {
    if (document.readyState === 'loading') {
        window.addEventListener('DOMContentLoaded', callback);
    }
    else {
        callback();
    }
}
exports.startOnLoaded = startOnLoaded;
exports.DOMContentLoaded = new Promise(function (resolve) { return startOnLoaded(resolve); });
function urlLinkPipe(value) {
    if (value && lodash_1.isString(value)) {
        return value.match(/^(http|https):\/\//) ? value : 'https://' + value;
    }
    else
        return '';
}
exports.urlLinkPipe = urlLinkPipe;
function htmlElement(tagName) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var classNames;
    var attributes;
    var i = 0;
    if (lodash_1.isString(args[i]))
        classNames = args[i++];
    if (lodash_1.isPlainObject(args[i]))
        attributes = args[i++];
    var el = document.createElement(tagName);
    if (classNames)
        addClass(el, classNames);
    if (attributes) {
        lodash_1.forEach(attributes, function (val, name) {
            el.setAttribute(name, val);
        });
    }
    return el;
}
exports.htmlElement = htmlElement;
function htmlDiv() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return htmlElement('div', args[0], args[1]);
}
exports.htmlDiv = htmlDiv;
function svgElement(tagName) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var classNames;
    var attributes;
    var i = 0;
    if (lodash_1.isString(args[i]))
        classNames = args[i++];
    if (lodash_1.isPlainObject(args[i]))
        attributes = args[i++];
    var el = document.createElementNS('http://www.w3.org/2000/svg', tagName);
    if (classNames)
        addClass(el, classNames);
    if (attributes) {
        lodash_1.forEach(attributes, function (val, name) {
            el.setAttribute(name, val);
        });
    }
    return el;
}
exports.svgElement = svgElement;
function empty(el) {
    while (el.firstChild)
        el.removeChild(el.firstChild);
}
exports.empty = empty;
function addClass(el, classNames) {
    var _a;
    if (el.classList) {
        for (var _i = 0, _b = classNames.split(/\s+/); _i < _b.length; _i++) {
            var className = _b[_i];
            el.classList.add(className);
        }
    }
    else {
        var appliedClasses = ((_a = el.getAttribute("class")) === null || _a === void 0 ? void 0 : _a.split(/s+/)) || [];
        for (var _c = 0, _d = classNames.split(/\s+/); _c < _d.length; _c++) {
            var className = _d[_c];
            if (!lodash_2.includes(appliedClasses, className))
                appliedClasses.push(className);
        }
        ;
        el.setAttribute('class', appliedClasses.join(' '));
    }
}
exports.addClass = addClass;
function removeClass(el, classNames) {
    var _a;
    if (el.classList) {
        for (var _i = 0, _b = classNames.split(/\s+/); _i < _b.length; _i++) {
            var className = _b[_i];
            el.classList.remove(className);
        }
    }
    else {
        var appliedClasses = ((_a = el.getAttribute("class")) === null || _a === void 0 ? void 0 : _a.split(/s+/)) || [];
        for (var _c = 0, _d = classNames.split(/\s+/); _c < _d.length; _c++) {
            var className = _d[_c];
            lodash_2.remove(appliedClasses, className);
        }
        ;
        el.setAttribute('class', appliedClasses.join(' '));
    }
}
exports.removeClass = removeClass;
function toggleClass(el, classNames, force) {
    var _a;
    if (el.classList) {
        for (var _i = 0, _b = classNames.split(/\s+/); _i < _b.length; _i++) {
            var className = _b[_i];
            // IE11 호환을 위해 el.classList.toggle(className, force)을 다음으로 대체함
            if (force === true) {
                el.classList.add(className);
            }
            else if (force === false) {
                el.classList.remove(className);
            }
            else {
                if (el.classList.contains(className)) {
                    el.classList.remove(className);
                }
                else {
                    el.classList.add(className);
                }
            }
        }
    }
    else {
        var appliedClasses = ((_a = el.getAttribute("class")) === null || _a === void 0 ? void 0 : _a.split(/s+/)) || [];
        for (var _c = 0, _d = classNames.split(/\s+/); _c < _d.length; _c++) {
            var className = _d[_c];
            if (force === true) {
                if (!lodash_2.includes(appliedClasses, className)) {
                    appliedClasses.push(className);
                }
            }
            else if (force === false) {
                lodash_2.remove(appliedClasses, className);
            }
            else {
                if (lodash_2.includes(appliedClasses, className)) {
                    lodash_2.remove(appliedClasses, className);
                }
                else {
                    appliedClasses.push(className);
                }
            }
        }
        ;
        el.setAttribute('class', appliedClasses.join());
    }
}
exports.toggleClass = toggleClass;
function hasClass(el, className) {
    var _a;
    if (el.classList) {
        return el.classList.contains(className);
    }
    else {
        var appliedClasses = ((_a = el.getAttribute("class")) === null || _a === void 0 ? void 0 : _a.split(/s+/)) || [];
        return lodash_2.includes(appliedClasses, className);
    }
}
exports.hasClass = hasClass;
function append(el) {
    var children = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        children[_i - 1] = arguments[_i];
    }
    for (var _a = 0, children_1 = children; _a < children_1.length; _a++) {
        var child = children_1[_a];
        if (child instanceof ElementHelper) {
            el.appendChild(child.element);
        }
        else if (lodash_2.isString(child)) {
            el.appendChild(document.createTextNode(child));
        }
        else {
            el.appendChild(child);
        }
    }
}
exports.append = append;
function remove(el) {
    var _a;
    (_a = el.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(el);
}
exports.remove = remove;
function after(el, other) {
    if (other instanceof ElementHelper) {
        el.insertAdjacentElement('afterend', other.element);
    }
    else {
        el.insertAdjacentElement('afterend', other);
    }
}
exports.after = after;
function before(el, other) {
    if (other instanceof ElementHelper) {
        el.insertAdjacentElement('beforebegin', other.element);
    }
    else {
        el.insertAdjacentElement('beforebegin', other);
    }
}
exports.before = before;
function setStyle(el, style) {
    if (lodash_1.isObject(style)) {
        lodash_1.each(style, function (value, name) {
            el.style[name] = value;
        });
    }
    else if (lodash_1.isString(style)) {
        el.setAttribute('style', style);
    }
}
exports.setStyle = setStyle;
var ElementHelper = /** @class */ (function () {
    function ElementHelper(el) {
        this.el = el;
    }
    Object.defineProperty(ElementHelper.prototype, "element", {
        get: function () {
            return this.el;
        },
        enumerable: false,
        configurable: true
    });
    ElementHelper.prototype.empty = function () {
        empty(this.el);
        return this;
    };
    ElementHelper.prototype.addClass = function (classNames) {
        addClass(this.el, classNames);
        return this;
    };
    ElementHelper.prototype.removeClass = function (classNames) {
        removeClass(this.el, classNames);
        return this;
    };
    ElementHelper.prototype.toggleClass = function (classNames, force) {
        toggleClass(this.el, classNames, force);
        return this;
    };
    ElementHelper.prototype.hasClass = function (className) {
        return hasClass(this.el, className);
    };
    ElementHelper.prototype.append = function () {
        var children = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            children[_i] = arguments[_i];
        }
        append.apply(void 0, __spreadArrays([this.el], children));
        return this;
    };
    ElementHelper.prototype.setAttr = function (name, value) {
        this.el.setAttribute(name, value);
        return this;
    };
    ElementHelper.prototype.getAttr = function (name) {
        return this.el.getAttribute(name);
    };
    ElementHelper.prototype.setText = function (text) {
        this.el.textContent = text == null ? null : text.toString();
        return this;
    };
    ElementHelper.prototype.getText = function () {
        return this.el.textContent;
    };
    ElementHelper.prototype.setInnerHtml = function (html) {
        this.el.innerHTML = html == null ? '' : html.toString();
        return this;
    };
    ElementHelper.prototype.on = function (type, listener) {
        this.el.addEventListener(type, listener);
        return this;
    };
    ElementHelper.prototype.findFirst = function (selector) {
        return this.el.querySelector(selector);
    };
    ElementHelper.prototype.findAll = function (selector) {
        return this.el.querySelectorAll(selector);
    };
    ElementHelper.prototype.parents = function (iterator) {
        for (var p = this.el.parentElement; p; p = p.parentElement) {
            if (iterator(p))
                return p;
        }
        return null;
    };
    ElementHelper.prototype.remove = function () {
        remove(this.el);
        return this;
    };
    ElementHelper.prototype.after = function (other) {
        after(this.el, other);
        return this;
    };
    ElementHelper.prototype.before = function (other) {
        before(this.el, other);
        return this;
    };
    ElementHelper.prototype.tap = function (callback) {
        callback(this);
        return this;
    };
    return ElementHelper;
}());
exports.ElementHelper = ElementHelper;
function $helper(el) {
    return new ElementHelper(el);
}
exports.$helper = $helper;
function $element(tagName) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return $helper(htmlElement(tagName, args[0], args[1]));
}
exports.$element = $element;
function $div() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return $helper(htmlDiv(args[0], args[1]));
}
exports.$div = $div;
function $svg(tagName) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return $helper(svgElement(tagName, args[0], args[1]));
}
exports.$svg = $svg;
function loadScriptCallback(url, callback) {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = url;
    script.onload = function () { return callback(url); };
    document.body.appendChild(script);
}
exports.loadScriptCallback = loadScriptCallback;
var LazyLoaderService = /** @class */ (function () {
    function LazyLoaderService() {
        this._loadedLibraries = {};
    }
    LazyLoaderService.prototype.script = function (url) {
        if (this._loadedLibraries[url]) {
            return this._loadedLibraries[url].asObservable();
        }
        var subject = new rxjs_1.ReplaySubject();
        this._loadedLibraries[url] = subject;
        loadScriptCallback(url, function () {
            subject.next(url);
            subject.complete();
        });
        return subject.asObservable();
    };
    return LazyLoaderService;
}());
exports.loader = new LazyLoaderService();
